import type { UseFecImportSessionResult } from '../hooks/useFecImportSession'

/** The ids sent with tracking events. The resume screen has no session imports yet, so it falls back to its own list. */
export const getFecImportTrackingIds = ({
  resumableFecImports,
  sessionFecImports,
}: Pick<UseFecImportSessionResult, 'resumableFecImports' | 'sessionFecImports'>): string[] =>
  (sessionFecImports.length > 0 ? sessionFecImports : resumableFecImports).map((fecImport) => fecImport.id)
